function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37405 6.13672L6.37402 6.13154C6.37402 3.94436 7.9114 2.00391 9.99937 2.00391C12.0873 2.00391 13.6247 3.94436 13.6247 6.13154L13.6247 6.13672H15.5035C15.7092 6.13672 15.8813 6.29265 15.9016 6.49729L16.9975 17.5618C17.0208 17.7971 16.8359 18.0012 16.5994 18.0012H3.40004C3.16354 18.0012 2.97868 17.7971 3.00199 17.5618L4.09789 6.49729C4.11816 6.29265 4.2903 6.13672 4.49594 6.13672H6.37405ZM7.5811 6.13154C7.5811 4.42389 8.74955 3.20697 9.99937 3.20697C11.2492 3.20697 12.4176 4.42389 12.4176 6.13154L12.4177 6.13672H7.58108L7.5811 6.13154ZM9.99966 11.3295C11.3193 11.3295 12.5185 10.0523 12.5185 8.30465C12.5185 8.0278 12.7437 7.80337 13.0215 7.80337C13.2992 7.80337 13.5244 8.0278 13.5244 8.30465C13.5244 10.4519 12.0178 12.332 9.99966 12.332C7.98153 12.332 6.4749 10.4519 6.4749 8.30465C6.4749 8.0278 6.70008 7.80337 6.97785 7.80337C7.25562 7.80337 7.4808 8.0278 7.4808 8.30465C7.4808 10.0523 8.67999 11.3295 9.99966 11.3295Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoppingBag);
export default __webpack_public_path__ + "static/media/icon-shopping-bag.9a2b78d2f7715179044d51ce10cdd40f.svg";
export { ForwardRef as ReactComponent };